import { createFileRoute, redirect } from '@tanstack/react-router'
import { getLoginAppOrigin } from '@/lib/login-app-url'
import { hasAccessToken } from '@/lib/token-storage'

export const Route = createFileRoute('/(auth)/abrir-conta')({
  beforeLoad: () => {
    const origin = getLoginAppOrigin()
    if (!origin) {
      if (hasAccessToken()) {
        throw redirect({ to: '/workspace' })
      }
      throw redirect({ to: '/configuracao-login' })
    }
    throw redirect({ href: `${origin}/abrir-conta` })
  },
})
